module.exports = __webpack_public_path__ + "img/iphone12.59d3e930.svg";